import * as React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import {
  Box,
  Button,
  Chip,
  IconButton,
  Link,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Switch,
  Typography,
} from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { BackArrowIcon, GoToLiveIcon, HighDemandIcon, TopRatingIcon, TrendingIcon } from '../icons'
import { GlobalStyles } from '@mui/material'
import ThreeDotMenu from '../components/university-table/ThreeDotMenu'
import UniversitySummary from '../components/university-table/UniversitySummary'
import courseUniversityRows from '../components/CourseListingManagement/data'
import { fetchCourseCategories, fetchCourseDashboardStats, fetchCourseList, fetchCourseNameList, fetchCourseNames } from '../api/courseApi'
import { updateTag } from '../api/tagApi'
import { updateStatus } from '../api/adminApi'
import { updateFlag } from '../api/footerApi'
import CommonFilterTab from '../components/common/CommonFilterTab'
import CommonTableFormat from '../components/common/CommonTableFormat'
import { useDispatch } from 'react-redux'
import { setPaginationFiled } from '../containers/pagination-container/reducer/paginationSlice'
import { useSelector } from 'react-redux'
import CommonDataTable from '../components/common/CommonDataTable'
import { defaultPaginationValues, filterTypeOptions, tagOptions, toogleOptions } from '../utils/constant'
import { formatMultiQueryParams, jsonParserFormatter } from '../utils/helperFunction'
import { setFilterField } from '../containers/filter-container/reducer/filterSlice'

const CourseListingManagement = ({ isHandlBtn = false }) => {
  const filterSlice = useSelector(state=>state.filter?.filters)
  const LOCATION_FILTER = `filters:${window.location.pathname}`
  const dispatch = useDispatch()
  const [rows, setRows] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const navigate = useNavigate()
  const [searchFilter, setSearchFilter] = React.useState({})
  const [rowCount, setRowCount] = React.useState(0);
  const [courseCategories,setCourseCategories] = React.useState([])
  const [courseSuggestion,setCourseSuggestion] = React.useState([])
  const [pageFilters, setPageFilters] =  React.useState(defaultPaginationValues);
  const [isRender,setIsRender] = React.useState(false)

  const handleFliterSliceChange = (values = {}, isReset = false) => {
    let isQuery = typeof values === "object" && Object.keys(values)?.length
    isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
  }

  React.useEffect(() => {
    setLoading(true)
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchCourseNameList(setRows, { ...searchFilter, ...multiFilter, isMultiFilter: true }, false, setRowCount)
      .finally(() => setLoading(false))
  }, [filterSlice[LOCATION_FILTER], isRender])


  // handle extra filter tabs changes
  React.useEffect(() => {
    if (pageFilters?.page) {
      handleFliterSliceChange({ page: 0 })
    } else {
      setIsRender(!isRender)
    }
  }, [searchFilter])

  // parse page filters
  React.useEffect(() => {
    const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
    setPageFilters(values)
  }, [filterSlice[LOCATION_FILTER]])

  // load course/ categories for filter suggestions
  React.useEffect(() => {
    fetchCourseCategories((result) => { setCourseCategories(result?.map(el => ({ ...el, value: encodeURIComponent(el?.label?.trim()) }))) }, {})
      .catch(() => { })

    fetchCourseNameList((result) => { setCourseSuggestion(result?.map(el => ({ label: el?.course, value: el?.course }))) }, {skipLimit:true})
      .catch(() => { })
  }, [])


  const handleChange = async (id, field, value) => {
    if (field === 'action') {
      if (value === 'View') {
        console.log('emit2')
        return;
      }

      if (value === 'Send to draft') {
        const prevStatus = rows.find(r => r.id === id)?.status || '';
        setRows(prev => prev.map(r => r.id === id ? { ...r, status: 'Draft' } : r));
        try {
          await updateStatus({
            id,
            status: 'draft',
            type: 'university',
          });
        } catch (err) {
          setRows(prev => prev.map(r => r.id === id ? { ...r, status: prevStatus } : r));
        }
        return;
      }
      return;
    }

    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    )
    if (field === 'tag') {
      try {
        await updateTag({
          id,
          tag: value,
          type: 'courseName',
        })
      } catch (err) {
        setRows((prev) =>
          prev.map((row) =>
            row.id === id ? { ...row, [field]: prev.find(r => r.id === id)?.tag || '' } : row
          )
        )
      }
    }
  }


  const handleToggle = (id, newValue, type, flagType) => {
    updateFlag({ id, isFooter: newValue, type, flagType })
      .catch(() => {
        setRows((prev) =>
          prev.map((row) =>
            row.id === id ? { ...row, [flagType]: !newValue } : row
          )
        );
      });

    setRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [flagType]: newValue } : row
      )
    );
  };


  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60, // fixed small width for serial number
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      // renderCell: (params) => rows?.findIndex((r) => r.id === params.row.id) + 1,
    },
    // {
    //   field: 'courseId',
    //   headerName: 'Course ID',
    //   flex: 1,
    //   minWidth: 130,
    //   cellClassName: 'sticky-col-1',
    //   headerClassName: 'sticky-col-1',
    // },
    {
      field: 'course',
      headerName: 'Course Name',
      flex: 2,
      minWidth: 220,
      filterColumnName:"name",
      filterType:filterTypeOptions.selection,
      selection:courseSuggestion,
      renderCell: (params) => {
        const { logo, course: name } = params.row

        const getInitials = (fullName) => {
          if (!fullName) return ''
          const words = fullName.trim().split(' ').filter(Boolean)
          if (words.length === 1) return words[0][0]?.toUpperCase() || ''
          if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase()
          return (words[0][0] + words[1][0] + words[2][0]).toUpperCase()
        }

        const stringToColor = (str) => {
          let hash = 0
          for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash)
          }
          const c = (hash & 0x00ffffff).toString(16).toUpperCase()
          return '#' + '00000'.substring(0, 6 - c.length) + c
        }

        const bgColor = stringToColor(name || 'Course')

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate(`/course-listing-management/variant-course/${params.row?.id}`)}
          >
            {logo ? (
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{
                  width: 40,
                  height: 40,
                  padding: '5px',
                  borderRadius: '50%',
                  objectFit: 'contain',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                  display: 'block',
                  maxHeight: 60,
                }}
              />
            ) : (
              <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: bgColor,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '10px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(name)}
              </Box>
            )}
            {params.value}
          </Box>
        )
      },
    },
    {
      field: 'courseCount',
      headerName: 'Variant Courses',
      flex: 1,
      minWidth: 100,
      filterColumnName:"courseCount",
      filterType:filterTypeOptions.numberRange,
      renderCell: (params) => {
        return loading ? (
          <Skeleton width={40} />
        ) : (
          <Chip 
          onClick={() => navigate(`/course-listing-management/variant-course/${params.row?.id}`)}
          label={params?.value} 
          sx={{ background: '#DFEDFF', color: '#363853' }} />
        )
      }
    },
    {
      field: 'isFooter',
      headerName: 'Footer',
      flex: 1,
      minWidth: 120,
      filterColumnName:"isFooter",
      filterType:filterTypeOptions.selection,
      selection:toogleOptions,
      renderCell: (params) => {
        return loading ? (
          <Skeleton width={40} />
        ) : (
          <Switch
            defaultChecked={Boolean(params?.value)}
            onChange={(e) => handleToggle(params.id, e.target.checked, 'courseName', 'isFooter')}
            color="primary"
            size="small"
          />
        );
      }
    },
    {
      field: 'isHomeVisible',
      headerName: 'Home Page',
      flex: 1,
      minWidth: 120,
      filterColumnName:"isHomeVisible",
      filterType:filterTypeOptions.selection,
      selection:toogleOptions,
      renderCell: (params) => {
        return loading ? (
          <Skeleton width={40} />
        ) : (
          <Switch
            defaultChecked={Boolean(params?.value)}
            onChange={(e) => handleToggle(params.id, e.target.checked, 'courseName', 'isHomeVisible')}
            color="primary"
            size="small"
          />
        );
      }
    },
    {
      field: 'specializationCount',
      headerName: 'Specializations',
      flex: 1,
      minWidth: 130,
      filterColumnName:"specializationCount",
      filterType:filterTypeOptions.numberRange,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={40} />
        ) : (
          <Chip 
          onClick={() => navigate(`/course-listing-management/variant-specialization/${params.row?.id}`)}
          label={params.value} 
          sx={{ background: '#DFEDFF', color: '#363853' }} />
        ),
    },
    // {
    //   field: 'university',
    //   headerName: 'University',
    //   flex: 1,
    //   minWidth: 130,
    //   renderCell: (params) =>
    //     loading ? (
    //       <Skeleton variant="circular" width={24} height={24} />
    //     ) : (
    //       <Chip label={params.value} sx={{ background: '#DFEDFF', color: '#363853' }} />
    //     ),
    // },
    // {
    //   field: 'status',
    //   headerName: 'Status',
    //   flex: 1,
    //   minWidth: 130,
    //   renderCell: (params) =>
    //     loading ? (
    //       <Skeleton width={70} />
    //     ) : (
    //       <Chip
    //         label={params.value}
    //         size="small"
    //         icon={
    //           <FiberManualRecordIcon
    //             className={getStatusClass(params.value)}
    //             sx={{ fontSize: 10, color: getStatusColor(params.value) }}
    //           />
    //         }
    //         sx={{
    //           bgcolor: getStatusBgColor(params.value),
    //           color: getStatusTextColor(params.value),
    //           fontWeight: 500,
    //         }}
    //       />
    //     ),
    // },
    {
      field: 'tag',
      headerName: 'Tag',
      flex: 1,
      minWidth: 180,
      filterColumnName:"tag",
      filterType:filterTypeOptions.selection,
      selection:tagOptions,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={100} />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%' }}>
            <Select
              value={params.row?.tag}
              onChange={(e) => handleChange(params.row.id, 'tag', e.target.value)}
              size="small"
              // disabled={selectedStatus === 'Deactivated'}
              fullWidth
              IconComponent={KeyboardArrowDownIcon}
              sx={{
                borderRadius: '50px',
                fontSize: '13px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '50px',
                },
                '& .MuiSelect-select': {
                  paddingY: '8px',
                  display: 'flex',
                  alignItems: 'center',
                },
              }}
            >
              {tagOptions.map((tag) => (
                <MenuItem key={tag?.value} value={tag?.value}>
                  <Box display="flex" alignItems="center" gap={1} sx={{ fontSize: '13px' }}>
                    {tag?.icon}
                    {tag?.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </Box>
        ),
    },
    { 
      field: 'courseCategory', 
      headerName: 'Course Category',
      flex: 1, 
       minWidth: 150,
      filterColumnName:"category",
      filterType:filterTypeOptions.selection,
      selection:courseCategories,
       },
    // { field: 'createdDate', headerName: 'Created Date', flex: 1, minWidth: 130 },
    // {
    //   field: 'action',
    //   headerName: 'Action',
    //   width: 100, // fixed width for action button menu
    //   renderCell: (params) =>
    //     loading ? <Skeleton width={80} /> : <ThreeDotMenu rowId={params.row.id} onAction={handleChange} />,
    // },
  ]


  return (
    <>
      {/* Apply global styles to DataGrid dropdown menus */}

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', }}>
          <div className="row align-items-center">
            <div className="col">
              <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/" className='d-flex'><BackArrowIcon /></Link>Course Listing Management</Typography>
            </div>
            {/* End Col */}
            {isHandlBtn && (<div className="col">  <Box display="flex" gap={2} sx={{ justifyContent: 'end', }}>

              <Button onClick={() => navigate('/course-listing-management/course-details')} sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}>
                Add New Course
              </Button>
            </Box></div>)}
          </div>
          {/* End Col */}
        </div>
        <UniversitySummary type="course" isAdmin />
        {/* Filter Toolbar */}
        <CommonFilterTab type='course' searchPlaceholder='Search course name...' detailType='Course Details' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} />

        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount} 
        pageFilters={pageFilters}
        handleFliterSliceChange={handleFliterSliceChange}
         />
 
      </Box>
    </>
  )
}

export default CourseListingManagement

